import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Gonzo Steampunk Vampires, Halloween and Beards",
  "description": "",
  "published": "2009-11-01T00:00:00.000Z",
  "redirect_from": ["/blog/gonzo-steampunk-vampires-halloween-and-beards/swizec/790"],
  "categories": "Halloween, Insanity, life, NaNoWriMo, Ugly Hill, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2009/11/IMG003511-300x225.jpg",
        "alt": "Emo Swizec",
        "title": "Emo Swizec"
      }}></img></p>
    <p>{`Yesterday was Halloween and as tradition goes, no this has got nothing to do with the americanisation of Slovenian culture, we've had halloween or some variation thereof for many centuries before america was ever discovered, people are supposed to dress up in scary costumes.`}</p>
    <p>{`This year I decided to partake, it happens sporadically, and after a lot of deliberation I finally decided I'd dress up as an Emo. It worked out fucking perfectly, got confused for a female at least five times and I'm told I looked downright 16 ... why I got liquor so easily though might be evidence against such claims. Unfortunately this is the only image I've got, I also had an emo backpack, emo fingernail job and some other tidbits that made me bloody awesome!`}</p>
    <p>{`Halloween being the last day of October brings us to another topic - `}<a parentName="p" {...{
        "href": "http://www.nanowrimo.org/",
        "title": "NaNoWriMo"
      }}>{`NaNoWriMo`}</a>{`.`}</p>
    <p>{`NaNoWriMo is an annual event that started nigh on ten years ago in the US and soon spread over the globe. The goal is to write a `}{`[`}{`short] novel of 50k words in a single month. You're supposed to write write write without fussing too much over perfection and details, those are for some other time. My first attempt was way back in 2005 when I actually managed to win by producing some utter garbage. Right the next year I failed.`}</p>
    <p>{`For some reason or another, insanity being most likely, I've decided to write a novel this month. Of course I'm not going to win because I simply don't have enough time and midterms will be starting in a few weeks. Yay. I also have no idea what I'm going to write about, but I've settled on doing something Steampunk in a Gonzo style (due to time restrictions) and the basic premise being Vampires, because @`}<a parentName="p" {...{
        "href": "http://twitter.com/tamejhna",
        "title": "tamejhna"
      }}>{`tamejhna`}</a>{` said so. We'll see what happens, but hopefully I'll produce a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Novella",
        "title": "Novella"
      }}>{`novella`}</a>{` of about 25k words, worthy of being published in Steampunk Magazine ... been a while since I published anything there.`}</p>
    <p>{`This month being November brings us to yet another bit of madness. Beardvember!`}</p>
    <p>{`The first I learned of beardvember was through `}<a parentName="p" {...{
        "href": "http://twitter.com/Southworth",
        "title": "Paul Southworth"
      }}>{`Paul Southworth`}</a>{` (@southworth) and his rants underneath the `}<a parentName="p" {...{
        "href": "http://www.uglyhill.com/",
        "title": "Ugly Hill"
      }}>{`Ugly Hill`}</a>{` comic, it's still a bloody shame he stopped drawing that). The idea here is that you leave your face to run wild with hair for a month and see what happens. If you're silly enough you also take a photo every day and then make a gif from it, which I'll attempt.`}</p>
    <p>{`So, uhm, yes ... THIS. IS. MADNESS! (completely unrelated to a certain popular meme of old)`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/4853c06e-6b29-4517-a3f6-9c7238344624/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=4853c06e-6b29-4517-a3f6-9c7238344624",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      